import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M.857 23.143 23.143.857M7.713 8.571h-2.57a1.714 1.714 0 0 0-1.715 1.715v3.428a1.714 1.714 0 0 0 1.715 1.715h2.57V8.57Zm9.43-1.714V5.143a1.714 1.714 0 0 0-.943-1.526 1.714 1.714 0 0 0-1.715.137L7.714 8.571m3.72 9.532 2.983 2.143a1.715 1.715 0 0 0 1.714.137 1.714 1.714 0 0 0 1.012-1.526V12m-9.43 3.429.498.36",
		stroke: "#404040",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.714
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M.857%2023.143%2023.143.857M7.713%208.571h-2.57a1.714%201.714%200%200%200-1.715%201.715v3.428a1.714%201.714%200%200%200%201.715%201.715h2.57V8.57Zm9.43-1.714V5.143a1.714%201.714%200%200%200-.943-1.526%201.714%201.714%200%200%200-1.715.137L7.714%208.571m3.72%209.532%202.983%202.143a1.715%201.715%200%200%200%201.714.137%201.714%201.714%200%200%200%201.012-1.526V12m-9.43%203.429.498.36%22%20stroke%3D%22%23404040%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.714%22%2F%3E%3C%2Fsvg%3E";
